import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Clock, AlertTriangle } from "lucide-react";

/**
 * Slim banner shown on Dashboard + list pages when the student is on trial
 * or when the trial/subscription has expired.
 */
export default function TrialBanner() {
  const { user } = useAuth();
  const sub = user?.subscription;
  if (!user || !sub || user.role === "admin") return null;

  if (sub.is_expired) {
    return (
      <div className="mb-6 border border-brand-crimson/40 bg-brand-crimson/10 rounded-2xl px-5 py-4 flex items-center justify-between gap-4 flex-wrap" data-testid="trial-banner-expired">
        <div className="flex items-center gap-3">
          <AlertTriangle className="w-5 h-5 text-brand-crimson" />
          <div>
            <div className="text-[10px] uppercase tracking-[0.3em] font-bold text-brand-crimson">Trial expired</div>
            <div className="font-mono text-sm text-foreground/80">Aap ab practice submit nahin kar sakte — please subscribe to continue.</div>
          </div>
        </div>
        <Link
          to="/subscribe"
          data-testid="banner-subscribe-link"
          className="px-5 py-2 rounded-lg bg-brand-crimson hover:bg-brand-crimson/90 text-white text-xs uppercase tracking-[0.2em] font-bold transition-colors"
        >
          Subscribe now →
        </Link>
      </div>
    );
  }

  if (sub.is_trial && sub.days_remaining <= 3) {
    return (
      <div className="mb-6 border border-brand-gold/40 bg-brand-gold/10 rounded-2xl px-5 py-3 flex items-center justify-between gap-4 flex-wrap" data-testid="trial-banner-active">
        <div className="flex items-center gap-3">
          <Clock className="w-5 h-5 text-brand-gold" />
          <div>
            <div className="text-[10px] uppercase tracking-[0.3em] font-bold text-brand-gold">Free trial</div>
            <div className="font-mono text-sm text-foreground/80">
              {sub.days_remaining} din baaki hai. Trial khatam hone se pehle subscribe karo taaki koi break na aaye.
            </div>
          </div>
        </div>
        <Link
          to="/subscribe"
          data-testid="banner-upgrade-link"
          className="px-5 py-2 rounded-lg bg-brand-gold hover:bg-brand-gold/90 text-background text-xs uppercase tracking-[0.2em] font-bold transition-colors"
        >
          Subscribe
        </Link>
      </div>
    );
  }

  return null;
}
